<template>
  <div>
    <RegistrationLayoutTitles :title="$t('common.verify_your_identity')"/>
    <div class="flex flex-col md:w-458 md:mx-auto">
      <p class="text-sm mt-5 text-grey-600 text-center mb-10">
        {{ $t('registration.mfa_preference.explanation') }}
      </p>
      <Form :validator="$v.model" :error="errorText">
        <FormRadioSelect
          v-model="model.mfaPreference"
          :data="modalityOptions"
          name="mfaPreference"
          :helperText="helperText"
          helperTextIconClass="fas fa-info-circle"
        />
      </Form>
      <div class="mx-auto flex-shrink-0 space-y-20 flex flex-col justify-center">
        <HMButton
          padding="wide"
          :class="{ 'mt-10': formHasError, 'mt-25': !formHasError }"
          :busy="isFetching"
          @click="onClick"
        >
          {{ $t('common.next_btn') }}
        </HMButton>
        <HMButton color="white" outlined padding="wide" @click="onCancel">
          {{ $t('common.cancel_btn') }}
        </HMButton>
      </div>
    </div>
  </div>
</template>

<script>
import _orderBy from 'lodash/orderBy'
import { required } from 'vuelidate/lib/validators'
import { MFA_TYPES } from '@platform-shared/constants'
import { Form, FormRadioSelect } from '@components/common/forms'
import RegistrationLayoutTitles from '@components/layouts/RegistrationLayoutTitles'

export default {
  components: {
    RegistrationLayoutTitles,
    FormRadioSelect,
    Form,
  },
  props: {
    helperText: {
      type: String,
      default: undefined
    },
    availableMfaModalities: {
      type: Array,
      required: true
    },
    isFetching: {
      type: Boolean,
      default: false
    },
    mfaPreference: {
      type: String
    },
    canCancel: {
      type: Boolean, default: true
    },
    errorText: {
      type: String
    },
  }, data() {
    return {
      modalityOrder: [MFA_TYPES.SMS, MFA_TYPES.VOICE, MFA_TYPES.EMAIL],
      model: {
        mfaPreference: undefined,
      },
    }
  },
  validations: {
    model: { mfaPreference: { required } },
  },
  computed: {
    formHasError() {
      return !!this.errorText
    },
    modalityOptions() {
      const options = this.availableMfaModalities
        .map((x) => ({
          code: x.type,
          label: this.$t(`mfa.modality.label.${x.type.toLowerCase()}`, [x.value])
        }))

      return _orderBy(
        options,
        [(modality) => this.modalityOrder.indexOf(modality.code)],
        ['asc']
      )
    },
  },
  mounted() {
    this.model.mfaPreference = this.mfaPreference || this.modalityOptions[0].code
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onClick() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.$emit('continue', this.model.mfaPreference)
    },
  },
}
</script>
